/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum UserVisibility {
	PRIVATE = 'PRIVATE',
	PUBLIC = 'PUBLIC',
}

//==============================================================
// END Enums and Input Objects
//==============================================================
